import React from "react";
import { theme, websiteColors } from "./../themes/Theme";

const HeaderBanner = () => {
    return (
        <div>
            <div className="header-banner d-flex justify-content-center ">
                <span className="banner-header-text">For Event Organizers in India</span>
                <span className="ps-2">
                    <img src="/img/India_badge.svg" alt="" />
                </span>
            </div>
            <style jsx>
                {
                    `
                    .header-banner{
                        background-color: ${websiteColors[theme].primaryWebsiteTheme};
                        padding:10px 0px;
                        align-items:center;
                    }
                    .banner-header-text{
                        font-size: 16px;
                        text-transform: uppercase;
                        color: white
                    }
                    `
                }
            </style>
        </div>
    )
}

export default HeaderBanner;